import type { FC } from 'react';
import React from 'react';
import type { DropdownMenuTriggerProps as RadixDropdownMenuTriggerProps } from '@radix-ui/react-dropdown-menu';
import { Trigger } from '@radix-ui/react-dropdown-menu';

type DropdownMenuTriggerProps = RadixDropdownMenuTriggerProps & React.RefAttributes<HTMLButtonElement>;

const DropdownMenuTrigger: FC<DropdownMenuTriggerProps> = ({ children, ...props }) => (
	<Trigger asChild {...props}>
		{children}
	</Trigger>
);

export default DropdownMenuTrigger;
